import React from 'react';
import { DotsThree } from '@phosphor-icons/react';
import { Menu } from '@headlessui/react';
import clsx from 'clsx';

interface Chat {
  id: string;
  title: string;
  created_at: string;
}

interface ChatLineProps {
  chat: Chat;
  onShare?: () => void;
  onDelete?: () => void;
  isActive?: boolean;
  onClick?: () => void;
}

export const ChatLine: React.FC<ChatLineProps> = ({ 
  chat,
  onShare, 
  onDelete, 
  isActive = false,
  onClick 
}) => {
  return (
    <div 
      className={clsx(
        "flex items-center justify-between px-3 py-1 hover:bg-[rgba(0,0,0,0.05)] rounded-lg cursor-pointer group",
        isActive && "bg-gray-100"
      )}
      onClick={onClick}
    >
      <span className="text-sm text-[#361E06] truncate flex-1">{chat.title}</span>
      
      <Menu as="div" className="relative">
        <div onClick={(e) => e.stopPropagation()}>
          <Menu.Button className="py-1 text-[#361E06] rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
            <DotsThree size={20} weight="bold" />
          </Menu.Button>

          <Menu.Items className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg py-1 z-10">
            {onShare && (
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={clsx(
                      "flex w-full px-4 py-2 text-sm text-gray-700",
                      active && "bg-gray-100"
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      onShare();
                    }}
                  >
                    Share chat
                  </button>
                )}
              </Menu.Item>
            )}
            {onDelete && (
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={clsx(
                      "flex w-full px-4 py-2 text-sm text-red-600",
                      active && "bg-gray-100"
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete();
                    }}
                  >
                    Delete chat
                  </button>
                )}
              </Menu.Item>
            )}
          </Menu.Items>
        </div>
      </Menu>
    </div>
  );
};
